import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWasmachineAansluiting1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M32 5H8v30h24z"
    />
    <path
      fill="#85E3F9"
      d="M20 31.78A8.89 8.89 0 1 0 20 14a8.89 8.89 0 0 0 0 17.78"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M12.12 22.71a.19.19 0 0 1 .36-.1 2.62 2.62 0 0 0 4.72-.38.19.19 0 0 1 .35 0 2.619 2.619 0 0 0 4.9 0 .19.19 0 0 1 .35 0 2.62 2.62 0 0 0 4.72.38.19.19 0 0 1 .36.1v10.78H12.12z"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M25.6 9.2a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M29.4 9.2a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20 14.5a8.5 8.5 0 1 0 8.5 8.5h1a9.5 9.5 0 1 1-9.5-9.5z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWasmachineAansluiting1);

export default ForwardRef;
